<template>
  <div>
    <article class="default-text">
      <h2>Reference</h2>
      <div class="perex">
        <p>Prohlédněte si naše referenční montáže různých budov z celé České republiky a Německa. Naše zakázky zajišťujeme od prvních vizualizací až po odbornou montáž se zárukou.</p>
      </div>
      <div class="buttons-group">
        <div>
          <v-btn
            @click="selectCategory(null)"
            variant="text"
            color="#f2cb45"
          >Vše
            <v-icon
              end
              size="10"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                fill="#f2cb45"
              >
                <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
              </svg>
            </v-icon>
          </v-btn>
        </div>


        <div v-for="category in categories" :key="category.id">
          <v-btn
            variant="text"
            color="#f2cb45"
            @click="selectCategory(category.id)"
          >
            {{ category.title }}
            <v-icon
              end
              size="10"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="#f2cb45">
                <path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/>
              </svg>
            </v-icon>
          </v-btn>
        </div>
      </div>
    </article>
    <div>
      <a
        v-for="subCategory in filteredSubCategories" :key="subCategory.id"
        class="glightbox"
        @click.prevent="openLightbox(subCategory)"
        >
        <img :src="subCategory.cover" :alt="subCategory.title">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff">
            <path d="M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149z" />
          </svg>
          <p>{{ subCategory.title }}</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import GLightbox from 'glightbox'
import 'glightbox/dist/css/glightbox.css'

export default {
  name: 'VPhotoGallery',
  props: {
    photoGalleries: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      selectedCategoryId: null,
      lightbox: null
    }
  },
  computed: {
    categories() {
      return Array.isArray(this.photoGalleries) ? this.photoGalleries : []
    },
    filteredSubCategories() {
      if (!Array.isArray(this.categories)) {
        return []
      }
      if (this.selectedCategoryId === null) {
        return this.categories.flatMap(c => c.subCategories || [])
      }
      const cat = this.categories.find(c => c.id === this.selectedCategoryId)
      return cat ? (cat.subCategories || []) : []
    }
  },
  mounted() {
    // one GLightbox instance for all opens
    this.lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
    })
  },
  beforeDestroy() {
    if (this.lightbox) this.lightbox.destroy()
  },
  methods: {
    selectCategory(id) {
      this.selectedCategoryId = id
    },
    openLightbox(subCategory) {
      const elements = [
        { href: subCategory.cover, type: 'image' },
        ...subCategory.photos.map(src => ({ href: src, type: 'image' }))
      ]
      // swap in new slides
      if (this.lightbox.setElements) {
        this.lightbox.setElements(elements)
      } else {
        this.lightbox = GLightbox({ elements, touchNavigation: true, loop: true })
      }
      this.lightbox.open()
    }
  }
}
</script>
